import { createAction, props } from '@ngrx/store'
import { CallingContext } from '@features/seasons/models/seasons.models'
import { Season } from '@core/models/season-competition.models'

export const fetchSeasons = createAction(
  '[Seasons] fetch seasons',
  props<{ includeMatchdays: boolean; callingContext: CallingContext }>()
)

export const setSeasonsByContext = createAction(
  '[Seasons] set season context',
  props<{ seasons: Season[]; callingContext: CallingContext }>()
)

export const setCurrentSeason = createAction(
  '[Seasons] Set current season',
  props<{ current: Season; callingContext: CallingContext; keepOriginalOnExist?: boolean }>()
)

export const setNoCompetitions = createAction('[Seasons] set no competitions')

export const purgeSeasons = createAction('[Seasons] purge')
